import script from "./esamiAggiuntiveEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./esamiAggiuntiveEdit.vue?vue&type=script&setup=true&lang=ts"

import "./esamiAggiuntiveEdit.vue?vue&type=style&index=0&id=1562a88e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1562a88e"]])

export default __exports__